import create from 'zustand';
import shallow from 'zustand/shallow';
import type { GetRoute, Routes } from '@hotjar/navigation/src/types';

import { TOPBAR_HEIGHT } from '@hotjar/navigation/src/constants';

const BANNER_HEIGHT = 48;

const calculateTopBarHeight = (extraBanners: number) =>
  extraBanners * BANNER_HEIGHT + TOPBAR_HEIGHT;

type NavigationState = {
  isSidebarMinimized: boolean;
  setIsSidebarMinimized: (isSidebarMinimized: boolean) => void;
  isSidebarHidden: boolean;
  setIsSidebarHidden: (isSidebarShown: boolean) => void;
  topBarHeight: number;
  extraBanners: number;
  setExtraBannersCount: (count: number) => void;
  routes: Routes;
  buildHrefFromRoute: GetRoute;
  initializeRoutes: (routes: Routes, getRoute: GetRoute) => void;
};

export const useNavigationStore = create<NavigationState>((set) => ({
  isSidebarMinimized: false,
  setIsSidebarMinimized: (isSidebarMinimized: boolean) => set({ isSidebarMinimized }),
  isSidebarHidden: false,
  setIsSidebarHidden: (isSidebarHidden: boolean) => set({ isSidebarHidden }),
  topBarHeight: TOPBAR_HEIGHT,
  extraBanners: 0,
  setExtraBannersCount: (count: number) =>
    set(() => ({
      extraBanners: count,
      topBarHeight: calculateTopBarHeight(count),
    })),
  routes: {},
  buildHrefFromRoute: () => '',
  initializeRoutes: (routes: Routes, getRoute: GetRoute) =>
    set({ routes, buildHrefFromRoute: getRoute }),
}));

export const useNavigation = (): NavigationState => useNavigationStore((state) => state, shallow);
